import SlideUpDown from 'vue-slide-up-down'

export default {
  SlideUpDown
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/schedule/resources/components.js